import { configureStore } from '@reduxjs/toolkit';
import { carsReducer } from './reducers/carsReducer';
import { usersReducer } from './reducers/usersReducer';
import { userLoginReducer, userRegisterReducer } from './reducers/userReducers';
import { alertsReducer } from './reducers/alertsReducer';
import { bookingsReducer } from './reducers/bookingsReducer';
import { createBrowserHistory } from 'history';
import { routerMiddleware, connectRouter } from 'connected-react-router';

export const history = createBrowserHistory();
const rootReducer = (history) => ({
    cars: carsReducer,
    users: usersReducer,
    alerts: alertsReducer,
    userLogin: userLoginReducer,
    userRegister: userRegisterReducer,
    bookings: bookingsReducer,
    router: connectRouter(history)
});

const userInfoFromStorage = localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user'))
    : null;

const initialState = {
    userLogin: { user: userInfoFromStorage },
};

const preloadedState = {};
const store = configureStore({
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(routerMiddleware(history)),
    reducer: rootReducer(history),
    initialState,
    preloadedState
});

export default store;